import { colors } from "colors"
import { StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  container: {
    marginTop: 10,
    width: "100%",
  },
  errorTextField: {
    borderColor: colors.error,
  },
  textField: {
    flex: 1,
    height: 50,
    padding: 4,
    paddingLeft: 10,
    paddingVertical: 10,
  },
  textFieldContainer: {
    alignItems: "center",
    backgroundColor: colors.inputFieldBackground,
    borderColor: colors.inputFieldBorder,
    borderRadius: 999,
    borderWidth: 1,
    flexDirection: "row",
    justifyContent: "center",
    marginBottom: 6,
    paddingRight: 10,
  },
  title: {
    fontFamily: typography.primary.normal,
    fontSize: 12,
    paddingHorizontal: 4,
  },
  titleContainer: {
    backgroundColor: colors.white,
    left: 15,
    opacity: 1,
    position: "absolute",
    top: -8,
    zIndex: 99,
  },
})
